export class LabelIdRequest {
    labellingId: number;
}